export interface PropertyRenterRequirementsDto {
  id: string;
  minimumCreditScore: number | null;
  minimumIncome: RenterRequirementsMinimumIncome | null;
  acceptsCosigners: boolean | null;
  screeningSensitivity: ScreeningSensitivity | null;
}

export enum RenterRequirementsMinimumIncome {
  X1_RENT = '1x monthly rent',
  X1_5_RENT = '1.5x monthly rent',
  X2_RENT = '2x monthly rent',
  X2_5_RENT = '2.5x monthly rent',
  X3_RENT = '3x monthly rent',
  X3_5_RENT = '3.5x monthly rent',
  NO_REQUIREMENT = 'No requirement',
}

export const minimumCreditScoreOptions = [
  'Excellent: 781 - 850',
  'Great: 721 - 780',
  'Good: 661 - 720',
  'Fair: 600 - 660',
  'Poor: 300 - 559',
];

export enum ScreeningSensitivity {
  STRICT = 'Strict',
  MODERATE = 'Moderate',
  OWNER_REVIEW = 'Owner Review',
}
